import React from "react"
import { ICustomFieldTemplate } from "../../entities/job/interface"
import { Switch } from "@mui/material"

interface Props {
    field: ICustomFieldTemplate
    value: boolean
    onChange: (id: string, value: boolean) => void
    isEditable: boolean
}

const SelectComponent: React.FC<Props> = ({ field, value, onChange, isEditable }) => {
    return (
        <Switch
            value={value}
            checked={value}
            disabled={!isEditable}
            onChange={(event) => onChange(field.customFieldTemplateId, event.target.checked)}
            sx={{
                "& .MuiSwitch-thumb": {
                    color: isEditable ? "white" : "black",
                },
                "& .MuiSwitch-track": {
                    bgcolor: "#00263a",
                },
                cursor: isEditable ? "pointer" : "not-allowed",
            }}
        />
    )
}

export default SelectComponent
